export const included = [
  'A comprehensive initial health and lifestyle assessment',
  'A personalised 12-week health plan',
  'Individual nutritional and dietary guidance',
  'Herbal medicine supplied as part of the programme where appropriate',
  'Regular one-to-one consultations and progress reviews',
  'More frequent contact during the early stages, adjusted as you progress',
  'Review of diet, lifestyle, sleep, movement and stress',
  'Support with emotional wellbeing where relevant',
  'Dietary and lifestyle diary review',
  'Symptom and progress tracking',
  'Regular review and adjustment of your programme',
  'Practical health education to help you better understand your body',
  'Support between appointments when needed',
  'An end-of-programme assessment',
  'A longer-term maintenance and self-management plan',
]

export const phases = [
  {
    weeks: 'Weeks 1–4',
    title: 'Foundation & Reset',
    paragraphs: [
      'We begin by establishing a clear picture of where you are now and identifying the areas that need the greatest attention.',
      'Your initial plan may include changes to nutrition, herbal medicine, sleep, movement, daily routines and other aspects of your health and lifestyle. The emphasis is on creating strong foundations and addressing your immediate priorities.',
    ],
  },
  {
    weeks: 'Weeks 5–8',
    title: 'Restore & Rebuild',
    paragraphs: [
      'As your programme progresses, we build on those foundations.',
      'This phase focuses more deeply on your individual nutritional needs and supporting the body systems and areas of health identified during your assessment.',
      'Your progress is reviewed, including changes in your symptoms, diet, lifestyle and general wellbeing. Your programme is then adjusted according to how you are responding.',
    ],
  },
  {
    weeks: 'Weeks 9–12',
    title: 'Strengthen & Optimise',
    paragraphs: [
      'The final phase focuses on consolidating the changes you have made and strengthening the practices that are working for you.',
      'We review how far you have come from your starting point, identify areas that may still require attention and develop a realistic approach for maintaining your health beyond the 12 weeks.',
    ],
  },
]
